import { render } from "./EditHeadphone.vue?vue&type=template&id=abd64226&lang=html"
import script from "./EditHeadphone.vue?vue&type=script&lang=js"
export * from "./EditHeadphone.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__